import React from 'react'

import { Typography } from '@mui/material'

const TextCell = ({ value = '-', ...rest }) =>
  <Typography textAlign='center' {...rest}>{value ?? '-'}</Typography>

export default React.memo(TextCell)
